// Kirim Tabung (/operations/dispatch): the three steps, phone first. "Titik Distribusi", never "lokasi".
import type { ShipmentKind } from '@lib/api/common';

export const DISPATCH_STEPS = ['Data kiriman', 'Muat tabung', 'Surat Jalan'] as const;

export const DISPATCH_SETUP = {
  stepsLabel: 'Langkah kirim tabung',
  stepOf: (n: number, total: number) => `Langkah ${n} dari ${total}`,
  kind: 'Jenis kiriman',
  /** what each kind is for, under its card */
  kindSub: { DISTRIBUTION: 'Kirim tabung ke Titik Distribusi berikutnya di jaringan', WITHDRAWAL: 'Tarik tabung ke Bengkel Uji untuk uji berkala atau karena rusak' } as Record<ShipmentKind, string>,
  /** only one kind leaves this place: it is stated, not asked */
  kindOnly: (kind: string) => `Kiriman dari Titik Distribusi ini berjenis ${kind}.`,
  kindsLoading: 'Memuat jenis kiriman…',
  kindsFailed: 'Jenis kiriman belum dapat dimuat.',
  /** no route at all from this type (a misconfigured place): nothing can be sent */
  kindsNone: 'Titik Distribusi ini belum dapat mengirim Surat Jalan. Hubungi administrator.',
  /** which types the chosen kind may go to ("Tujuan: SPBG atau Hub") */
  allowedTo: (types: string) => `Tujuan yang dapat dipilih: ${types}.`,
  or: 'atau',
  destination: 'Tujuan',
  suggested: 'Titik Distribusi terdekat di jaringan',
  suggestedLoading: 'Memuat Titik Distribusi…',
  suggestedNone: 'Belum ada tujuan yang disarankan. Cari tujuan di bawah.',
  /** the destination waits for the kind */
  kindFirst: 'Pilih jenis kiriman dulu.',
  searchOther: 'Cari Titik Distribusi lain',
  searchPlaceholder: 'Nama atau kode Titik Distribusi…',
  change: 'Ganti',
  chosen: 'Tujuan dipilih',
  vehicle: 'Kendaraan & sopir',
  plate: 'Nomor polisi kendaraan',
  platePlaceholder: 'Contoh: B 1234 XYZ',
  driver: 'Nama sopir',
  driverPlaceholder: 'Contoh: Budi Santoso',
  remembered: 'Sopir & kendaraan terakhir diingat untuk kiriman berikutnya.',
  useLast: 'Gunakan terakhir',
  summary: 'Ringkasan',
  vehicleShort: 'Kendaraan',
  driverShort: 'Sopir',
  notYet: 'Belum diisi',
  start: 'Mulai muat tabung',
  blocked: {
    kind: 'Pilih jenis kiriman',
    dest: 'Pilih Titik Distribusi tujuan',
    plate: 'Isi nomor polisi kendaraan',
    plateFormat: 'Periksa format nomor polisi',
    driver: 'Isi nama sopir',
  },
} as const;

export const DISPATCH_LOAD = {
  loaded: 'Tabung dimuat',
  listCount: (n: number) => `${n} tabung`,
  to: 'Ke',
  depart: (n: number) => `Berangkatkan · ${n} tabung`,
} as const;

/** A withdrawal's loading list: each cylinder's reason. */
export const DISPATCH_REASON = {
  label: (serial: string) => `Alasan penarikan ${serial}`,
  /** a cylinder whose retest is not due: the operator says why it goes */
  ask: 'Pilih alasan penarikan',
  saving: 'Menyimpan…',
  /** the departure waits for the reasons */
  held: (n: number) => `Pilih alasan untuk ${n} tabung sebelum berangkat.`,
  /** in the departure's confirmation */
  summary: (retest: number, damaged: number) => `${retest} tabung untuk uji berkala, ${damaged} tabung rusak.`,
} as const;

export const DISPATCH_ISSUED = {
  title: 'Surat Jalan terbit',
  kind: 'Jenis',
  destination: 'Tujuan',
  load: 'Muatan',
  driver: 'Sopir',
  cylinders: (n: number) => `${n} tabung`,
  /** "Semua tabung kini berstatus <b>Dalam pengiriman</b>. Saat dibongkar …" */
  inTransitBefore: 'Semua tabung kini berstatus ',
  inTransitStatus: 'Dalam pengiriman',
  inTransitAfter: (dest: string) => `. Saat dibongkar di ${dest}, petugas di sana tinggal memindai; isi kiriman dicocokkan otomatis.`,
  received: (dest: string) => `Kiriman ini sudah diterima di ${dest}.`,
  print: 'Cetak / Bagikan PDF ke sopir',
  share: 'Bagikan tautan',
  again: 'Kirim lagi',
} as const;
